export enum EnrollPhasesEnum {
  PersonalDetails = 1,
  PurposeAndStatus,
  KnowledgeAndExperience,
}
